import { summaryMapper } from 'container/summaryMapper';
import { opinionQuestionMapper } from 'container/opinionQuestionMapper';

import { OverallSurveyMapper } from '../mapper/OverallSurveyMapper';

export const overallSurveyMapper = new OverallSurveyMapper(summaryMapper, opinionQuestionMapper);
